import React, { useEffect, useState } from "react";
import MainContainer from "../../layout/MainContainer";
import { showError } from "../../constants/toasts";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useLazyGetBroadcastMembersQuery } from "../../service/notification";
import SearchBar from "../../components/SearchBar";
import { isValidInput } from "../../utils/validations";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import dayjs from "dayjs";
import { formatDubaiDateTime } from "../../utils/dateTime";
import Loader from "../../constants/Loader";
import { USER_STATUS } from "../../utils/enums";

const ViewUsers = () => {
  const { id } = useParams();
  const location = useLocation();
  const { state } = location;
  const navigate = useNavigate();
  const [getMember] = useLazyGetBroadcastMembersQuery();

  const [searchTerm, setSearchTerm] = useState("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [loading, setLoading] = useState(false);
  const [hasFetched, setHasFetched] = useState(false);
  const [users, setUsers] = useState([]);
  const [page, setPage] = useState(1);

  const goToBack = () => {
    navigate(-1);
  };

  const getUsersApi = async () => {
    setLoading(true);
    try {
      const response = await getMember({
        id,
        page: page,
        search: debouncedSearchTerm.trim(),
      }).unwrap();
      setLoading(false);
      setHasFetched(true);
      if (response.status === 200) {
        setUsers(response?.data?.items || []);
      } else {
        setUsers([]);
      }
    } catch (error: any) {
      setHasFetched(true);
      setLoading(false);
      showError(error?.data?.message || "");
    }
  };

  useEffect(() => {
    getUsersApi();
  }, [debouncedSearchTerm, page]);

  return (
    <MainContainer>
      <Loader isLoad={loading} />
      <div className="main_title d_flex">
        <div className="left_s">
          <h1>Users List</h1>
        </div>
        <div className="right_s">
          <SearchBar
            searchTerm={searchTerm}
            placeholder="Search...."
            setDebouncedSearchTerm={setDebouncedSearchTerm}
            value={searchTerm}
            onCross={() => setSearchTerm("")}
            onChange={(val: any) => {
              if (isValidInput(val.target.value)) {
                setSearchTerm(val.target.value);
              }
            }}
          />
          <Button className="btn btn_primary" onClick={goToBack}>
            Back
          </Button>
        </div>
      </div>
      <div className="cards table_cards">
        <TableContainer className="table_container">
          <Box className="heading"></Box>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Created Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users?.length ? (
                users?.map((row: any, i: any) => (
                  <TableRow key={i}>
                    <TableCell
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        navigate(`/manage-customers/detail/${row?.userId}`, {
                          state: {
                            status:
                              row?.userStatus === USER_STATUS.Approved
                                ? "APPROVED"
                                : row?.userStatus === USER_STATUS.Rejected
                                  ? "REJECTED"
                                  : row?.userStatus === USER_STATUS.Expired
                                    ? "EXPIRED"
                                    : row?.userStatus === USER_STATUS.Cancelled
                                      ? "CANCELLED"
                                      : "PENDING",
                            memberType: row?.membershipType,
                          },
                        })
                      }
                    >
                      <p>{row?.userName || "-"}</p>
                    </TableCell>
                    <TableCell>
                      <p>{row?.userEmail || "-"}</p>
                    </TableCell>
                    <TableCell>
                      <p>
                        {row?.createdAt
                          ? formatDubaiDateTime(row?.createdAt)
                          : "-"}
                      </p>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={3}
                    style={{ textAlign: "center", padding: "20px" }}
                  >
                    No Data Found
                  </td>
                </tr>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </MainContainer>
  );
};

export default ViewUsers;
